import { useParams } from 'react-router-dom'

export function useExaminerId() {
  const { id } = useParams<{ id?: string }>()

  return id ? Number(id) : 0
}
